import React, { useEffect, useState } from 'react';
import { IonPage, IonContent, IonCard, IonCardContent, IonRow, IonCol, IonButton, IonIcon } from '@ionic/react';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { connect } from 'react-redux';

import { SessionDefaultStateI } from '../../store/session/SessionReducer';
import { ABMMenuDefaultStateI } from '../../store/ABMMenu/ABMMenuReducer';
import { addCircleOutline } from 'ionicons/icons';
import { GetABMMenu } from '../../store/ABMMenu/ABMMenuActions';


import Header from '../header/Header';
import Footer from '../Footer/Footer';
import Loading from "../Loading/Loading";
import ABMMenuTable, { Data } from './ABMMenuTable';
import AddABMMenu from './AddABMMenu';
import ModifyABMMenu from './ModifyABMMenu';
import ApiRequestor from '../../api_access/ApiRequestor';
import "./ABMMenu.css";
import Modal from '../Modal/Modal';

interface Props extends StateTypes, dispatchTypes { }

const ABMMenuMainView: React.FC<Props> = (props) => {
  const [items, setItems] = useState<Data[]>([]);
  const sensors = useSensors(useSensor(PointerSensor));
  const [renderViews, setRenderViews] = useState<any>({
    showTable: true,
    showCreate: false,
    showModify: false
  })
  const [dataToModyfy, setDataToModify] = useState<Data>({
    menuinfo_name: '',
    menuinfo_title: '',
    menuinfo_url: '',
    menuinfo_id: 0,
    menuinfo_category: [''],
    menuinfo_order: 0,
  })
  const [showModal, setShowModal] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);

  useEffect(() => {
    if (!props.session.loading && props.session.loginData) {
      props.getABMMenu()
    }
  }, [props.session.loading, props.session.loginData]);

  useEffect(() => {
    if (props.ABMMenu.loading === false && props.ABMMenu.abmmenu) {
      const data = props.ABMMenu.abmmenu.data
      setItems(data);
    }
  }, [props.ABMMenu.loading, props.ABMMenu.abmmenu])

  const SortableRow: React.FC<{ item: Data; index: number }> = ({ item, index }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
      id: item.menuinfo_id
    });

    const style = {
      transform: CSS.Transform.toString(transform),
      transition,
    };

    return (
      <div ref={setNodeRef} style={style} {...attributes}>
        <ABMMenuTable
          menuData={item}
          index={index}
          dragListeners={listeners}
          onModify={renderModify}
        />

      </div>

    );
  };

  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = items.findIndex((item) => item.menuinfo_id === active.id);
      const newIndex = items.findIndex((item) => item.menuinfo_id === over.id);
      setItems(arrayMove(items, oldIndex, newIndex));
    }
  };

  const saveOrder = async () => {
    const orderedItems = items.map((item, index) => ({
      menuinfo_id: item.menuinfo_id,
      menuinfo_order: index + 1
    }));

    const data: any = {
      body: {
        items: orderedItems
      }
    };

    const response = await ApiRequestor.requestToApi('/swt-admin/menu-info/order', 'POST', data);

    if (response && response.status === 200) {
      props.getABMMenu();
      setShowModal(false);
      setShowModalSuccess(true);
    }
  };

  const renderCreate = () => {
    setRenderViews({
      showTable: false,
      showCreate: true,
      showModify: false
    })
  };

  const renderModify = (data: Data) => {
    setRenderViews({
      showTable: false,
      showCreate: false,
      showModify: true
    })
    setDataToModify(data)
  };

  const orderItemMenuModal = () => {
    setShowModalSuccess(false);
}

  return (
    <IonPage>
      <Header headerText="ABM Menu" />
      {
        renderViews.showCreate ? <AddABMMenu backToTable={() => setRenderViews({ showTable: true, showCreate: false, showModify: false })}/> :
          renderViews.showModify ? renderViews.showModify && (
            <ModifyABMMenu
              dataToModify={dataToModyfy}
              backToTable={() => setRenderViews({ showTable: true, showCreate: false, showModify: false })}
            />
          )

            :
            renderViews.showTable && props.ABMMenu.loading === false && props.ABMMenu.abmmenu ?
              <div className="custom-content-scroll">
                <IonCard className="abmmenu-contenedor">
                  <IonRow className="ion-padding justify-abm">
                    <IonButton className="container-button-add" fill='clear' onClick={renderCreate} >
                      <IonIcon icon={addCircleOutline} color="secondary" size="large" />
                    </IonButton>
                  </IonRow>
                  <IonCardContent className="abmmenu-table abmmenu-table-card abmmenu-table-margin-card">
                    <IonRow className="abmmenu-table-rows">
                      <IonCol className="abmmenu-table-title abmmenu-hiden" size="1">Menu</IonCol>
                      <IonCol className="abmmenu-table-title" sizeXl='2' sizeXs='5'>Título</IonCol>
                      <IonCol className="abmmenu-table-title abmmenu-hiden" sizeXl='1'>Icono</IonCol>
                      <IonCol className="abmmenu-table-title abmmenu-hiden" sizeXl='2'>URL</IonCol>
                      <IonCol className="abmmenu-table-title abmmenu-hiden" sizeXl='3'>Perfiles</IonCol>
                      <IonCol className="abmmenu-table-title abmmenu-hiden" size='1'>Orden</IonCol>
                      <IonCol className="abmmenu-table-title" sizeXl='1' sizeXs='4'>Modificar</IonCol>
                      <IonCol className="abmmenu-table-title" sizeXl='1' sizeXs='3'>Eliminar</IonCol>
                    </IonRow>
                    <DndContext
                      sensors={sensors}
                      collisionDetection={closestCenter}
                      onDragEnd={handleDragEnd}
                    >
                      <SortableContext
                        items={items.map((item) => item.menuinfo_id)}
                        strategy={verticalListSortingStrategy}
                      >
                        {items.map((item, index) => (
                          <SortableRow key={item.menuinfo_id} item={item} index={index} />
                        ))}
                      </SortableContext>
                    </DndContext>
                    <IonRow className='abmmenu-boton-contenedor abmmenu-hiden' >
                      <IonButton fill="outline" className="abmmenu-boton-orden" onClick={() => setShowModal(true)}>
                        GUARDAR ORDEN
                      </IonButton>
                    </IonRow>

                  </IonCardContent>
                </IonCard>
                <Modal
                modalPrincipal={
                    {
                        textPrincipal: `¿Deseas Modificar el orden del menú?`,
                        isOpen: showModal,
                        onDidDismiss: () => setShowModal(false),
                        onClick: () => saveOrder(),
                        onClickCloseModal: () => setShowModal(false),
                        nameIcon: "warning",
                        colorIcon: "danger",

                    }
                }
                modalConfirmation={
                    {
                        isOpenModalConfirm: showModalSuccess,
                        onDidDimissConfirmModal: () => orderItemMenuModal(),
                        textConfirmation: "Orden actualizado con Éxito",
                        onClickConfirmModal: () => setShowModalSuccess(false)

                    }
                }
            />
              </div>
              :
              <Loading />
      }
      <Footer />
    </IonPage>
  );
};

interface StateTypes {
  session: SessionDefaultStateI;
  ABMMenu: ABMMenuDefaultStateI;
}

const mapStateToProps = (state: StateTypes) => ({
  session: state.session,
  ABMMenu: state.ABMMenu
});

interface dispatchTypes {
  getABMMenu: () => void;
}

const mapDispatchToProps = (dispatch: any) => ({
  getABMMenu: () => dispatch(GetABMMenu())
});

export default connect(mapStateToProps, mapDispatchToProps)(ABMMenuMainView);
